import React from "react";

const BAND_CLASS = {
  within:   "s-active",
  at_risk:  "s-rev",
  breached: "s-fail",
  neutral:  "s-mute",
};

function SLACountdown({ deadline, size }) {
  const cls = (band) => `tbl-status ${BAND_CLASS[band]}`;

  if (!deadline) {
    return <span className={cls("neutral")}>—</span>;
  }

  const deadlineMs =
    deadline instanceof Date ? deadline.getTime() : new Date(deadline).getTime();
  if (!Number.isFinite(deadlineMs)) {
    return <span className={cls("neutral")}>—</span>;
  }

  const nowMs = Date.now();
  const diffMs = deadlineMs - nowMs;
  const absHours = Math.abs(diffMs) / (3600 * 1000);

  const formatRemaining = (h) =>
    h < 1 ? `${Math.max(1, Math.round(h * 60))}m` : `${h.toFixed(0)}h`;

  let band;
  let label;
  if (diffMs <= 0) {
    band = "breached";
    label = `Breached · ${formatRemaining(absHours)} over`;
  } else if (diffMs <= 12 * 3600 * 1000) {
    band = "at_risk";
    label = `At risk · ${formatRemaining(absHours)} left`;
  } else {
    band = "within";
    label = `${formatRemaining(absHours)} left`;
  }

  const style = size === "large" ? { fontSize: "var(--t-sm)", padding: "3px 9px" } : undefined;
  return (
    <span
      className={cls(band)}
      title={`Deadline: ${new Date(deadlineMs).toLocaleString()}`}
      style={style}
    >
      {label}
    </span>
  );
}

export default SLACountdown;
